export enum DownloadFormat {
  xlsx = 'xlsx',
  csv = 'csv',
  zip = 'zip',
}
